import formbricks from "@formbricks/js";

export default defineNuxtPlugin((nuxtApp) => {
  formbricks.init({
    environmentId: "cm4jre89w001h9mzanv3hljui",
    apiHost: "https://app.formbricks.com",
  });

  nuxtApp.$router.afterEach(path => {
    formbricks.registerRouteChange();
  });
})
